module.exports = __webpack_public_path__ + "static/img/12.c576443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/12.png
// module id = W0Nr
// module chunks = 1